package diana.soleil.design.iraniancanadienbazzar.core.devmenu

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.update

/**
 * Central registry of feature-contributed [DevTool]s. Provided as a Koin singleton so any feature can
 * [register] its debug affordances at startup; the Developer Menu renders whatever is registered. Keeps
 * debug code out of production screens and makes testing tools discoverable in one place.
 *
 * Registration is idempotent by [DevTool.id] (re-registering replaces the prior entry), so it's safe to
 * call from a `LaunchedEffect` that may re-run.
 */
class DevMenuRegistry {
    private val _tools = MutableStateFlow<List<DevTool>>(emptyList())
    val tools: StateFlow<List<DevTool>> = _tools

    fun register(tool: DevTool) = _tools.update { current ->
        // Replace IN PLACE, not remove-and-append: tools re-register themselves to refresh their
        // subtitle after being tapped (the feature-flag toggles do this on every tap), and appending
        // made the row you just tapped jump to the bottom of the list.
        val index = current.indexOfFirst { it.id == tool.id }
        if (index >= 0) current.toMutableList().also { it[index] = tool } else current + tool
    }

    fun unregister(id: String) = _tools.update { current -> current.filterNot { it.id == id } }
}
